<div class="flex-container">

  <fadv-box>

    <fadv-grid>

        <fadv-grid-row style="padding-bottom: 2%">
          <fadv-grid-col alignment="center" col="12">
            <div style="text-align: center">
              <fadv-typography type="heading-small">How will the applicant details be provided?</fadv-typography>
            </div>
          </fadv-grid-col>
        </fadv-grid-row>
      
      <fadv-grid-row>
        <fadv-grid-col id="cardContainerColumn" [col]="{ xxl: 6, xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }">
          <fadv-card id="card1" (click)="selectOrderType('invite')">
            <fadv-card-header>
              <div [ngClass]="this.currentOrderType === 'invite' ? 'card-header-formatting selected' : 'card-header-formatting'">
                <fadv-typography type="label-large" strong="true" weight="500" variant="white">Applicant Submission</fadv-typography>
              </div>
            </fadv-card-header>
            <fadv-card-body>
              <fadv-box pt="medium" ph="medium">
                <fadv-grid>
                  <fadv-grid-row id="cardRow1">
                    <fadv-typography type="label-medium" weight="500" id="cardTop">What this means</fadv-typography>
                  </fadv-grid-row>
                  <fadv-grid-row id="cardRow2">
                    <fadv-typography type="label-small">A link will be sent to the applicant's email allowing them to submit their required order information.</fadv-typography>
                  </fadv-grid-row>
                  <fadv-grid-row id="cardRow3">
                    <fadv-grid [gutter]="'small'">
                      <ul>
                        <li>
                          <fadv-box mb="small">
                            <fadv-grid-row>
                              <fadv-grid-col [col]="1">
                                <fadv-icon size="x-small" library="solid" name="fa-circle-check" foreground="success" style="padding-right:5px;" >  </fadv-icon>
                              </fadv-grid-col>
                              <fadv-grid-col [col]="11" style="padding-left:15px;">
                                <fadv-typography type="paragraph-x-small" weight="400">Applicants will be presented a disclosure(s) and then an authorization for signature.</fadv-typography>
                              </fadv-grid-col>
                            </fadv-grid-row>
                          </fadv-box>
                        </li>
                        <li>
                          <fadv-box [mb]="{ xxl: 'x-large', xl: 'x-large', lg: 'medium' }">
                            <fadv-grid-row>
                              <fadv-grid-col [col]="1">
                                  <fadv-icon size="x-small" library="solid" name="fa-circle-check" foreground="success" style="padding-right:5px;" >  </fadv-icon>
                              </fadv-grid-col>
                              <fadv-grid-col [col]="11" style="padding-left:15px;">
                                <fadv-typography type="paragraph-x-small" weight="400">The background check order will be submitted when the applicant completes the form.</fadv-typography>
                              </fadv-grid-col>
                          </fadv-grid-row>
                        </fadv-box>
                        </li>
                      </ul>
                    </fadv-grid>
                  </fadv-grid-row>
                  <fadv-box mb="medium" [mt]="{ xxl: 'large', xl: 'xx-small', lg: 'xxx-small' }">
                  <fadv-grid-row [ngSwitch]="currentOrderType === 'invite'">
                    <fadv-button *ngSwitchCase="false" id="cardButton" name="candidate-arrow-button">Enter Applicant&nbsp;&nbsp;&nbsp;<i class="arrow right"></i></fadv-button>
                    <fadv-button *ngSwitchCase="true" id="cardButton" variant="primary" name="candidate-selected-button-1">Selected<fadv-icon fadvPrefixIcon library='solid' foreground='white' name='check-double'></fadv-icon></fadv-button>
                  </fadv-grid-row>
                </fadv-box>
                </fadv-grid>
              </fadv-box>
            </fadv-card-body>
        </fadv-card>
      </fadv-grid-col>

      <fadv-grid-col id="cardContainerColumn" [col]="{ xxl: 6, xl: 6, lg: 6, md: 12, sm: 12, xs: 12 }">
        <fadv-card id="card1" (click)="selectOrderType('online')">
          <fadv-card-header>
            <div [ngClass]="this.currentOrderType === 'online' ? 'card-header-formatting selected' : 'card-header-formatting'">
              <fadv-typography type="label-large" strong="true" weight="500" variant="white">Employer Submission</fadv-typography>
            </div>
          </fadv-card-header>
          <fadv-card-body>
            <fadv-box pt="medium" ph="medium">
              <fadv-grid>
                <fadv-grid-row id="cardRow1">
                  <fadv-typography type="label-medium" weight="500" id="cardTop">What this means</fadv-typography>
                </fadv-grid-row>
                <fadv-grid-row id="cardRow2">
                  <fadv-typography type="label-small">You submit applicant’s required information on their behalf.</fadv-typography>
                </fadv-grid-row>
                <fadv-grid-row id="cardRow3">
                  <fadv-grid [gutter]="'small'">
                    <ul>
                      <li>
                        <fadv-box mb="small">
                          <fadv-grid-row>
                            <fadv-grid-col [col]="1">
                              <fadv-icon size="x-small" library="solid" name="fa-circle-check" foreground="success" style="padding-right:5px;" >  </fadv-icon>
                            </fadv-grid-col>
                            <fadv-grid-col [col]="11" style="padding-left:15px;">
                              <fadv-typography type="paragraph-x-small" weight="400">You are responsible for presenting and collecting necessary forms from the applicant to comply with applicable laws.</fadv-typography>
                            </fadv-grid-col>
                          </fadv-grid-row>
                        </fadv-box>
                      </li>
                      <li>
                        <fadv-grid-row>
                          <fadv-grid-col [col]="1">
                              <fadv-icon size="x-small" library="solid" name="fa-circle-check" foreground="success" style="padding-right:5px;" >  </fadv-icon>
                          </fadv-grid-col>
                          <fadv-grid-col [col]="11" style="padding-left:15px;">
                            <fadv-typography type="paragraph-x-small" weight="400">The background check order will be submitted when you complete the form and payment.</fadv-typography>
                          </fadv-grid-col>
                      </fadv-grid-row>
                      </li>
                    </ul>
                  </fadv-grid>
                </fadv-grid-row>
                <fadv-box mb="medium" [mt]="{ xxl: 'undefined', xl: 'small' }">
                <fadv-grid-row [ngSwitch]="currentOrderType === 'online'">
                  <fadv-button *ngSwitchCase="false" id="cardButton" name="candidate-online-button">Enter Details Myself&nbsp;&nbsp;&nbsp;<i class="arrow right"></i></fadv-button>
                  <fadv-button *ngSwitchCase="true" id="cardButton" variant="primary" name="candidate-selected-button-2">Selected<fadv-icon fadvPrefixIcon library='solid' foreground='white' name='check-double'></fadv-icon></fadv-button>
                </fadv-grid-row>
              </fadv-box>
              </fadv-grid>
            </fadv-box>
          </fadv-card-body>
        </fadv-card>
      </fadv-grid-col>
    </fadv-grid-row>
        <fadv-grid-row style="padding-bottom: 5%">
          <fadv-grid-col
          class="back-button-col"
           alignment="{{backButtonAlignment}}" 
           [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }">
            <fadv-button size="large" 
            (click)="onCancel()"
            class="form-button"
            name="candidate-back-button">Back</fadv-button>
          </fadv-grid-col>
          <fadv-grid-col 
          class="next-button-col"
          alignment="{{nextButtonAlignment}}" 
          [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }">
            <fadv-button size="large" 
            (click)="handleNext()"
            [disabled]="this.currentOrderType == undefined"
            variant="primary"
            class="form-button"
            name="candidate-next-button">Next</fadv-button>
          </fadv-grid-col>
        </fadv-grid-row>
    </fadv-grid>
  </fadv-box>
  </div>